import type { DynamicClient } from '../../../../client/types';
import type { Chain } from '../../../chain';
import { getNetworksData } from '../getNetworksData';
import type { NetworkData } from '../networkProvider/networkProvider.types';

type GetNetworkDataForNetworkIdProps = {
  chain: Chain;
  networkId: string;
};

export const getNetworkDataForNetworkId = (
  { networkId, chain }: GetNetworkDataForNetworkIdProps,
  client: DynamicClient
): NetworkData | undefined => {
  const networksData = getNetworksData(client);

  const networkData = networksData.find(
    (networkData) =>
      networkData.networkId === networkId && networkData.chain === chain
  );

  return networkData;
};
